module.exports = __webpack_public_path__ + "img/body-bg.ddf0276c.png";